const labelsValidationES = {
    "name": {
        "required": "El nombre del sello es obligatorio",
        "unique": "¡Vaya! Este sello ya existe y es propiedad de otro usuario. Por favor, intenta con otro nombre de sello. Si legalmente posees este nombre de sello y tienes el copyright del nombre, por favor contacta a nuestro equipo de soporte.",
        "available": "El nombre del sello está disponible",
        "invalid": "El nombre del sello no es válido"
    },
    "year": {
        "required": "El año de establecimiento es obligatorio",
        "numeric": "El valor no es un número",
        "stringLength": "El año de establecimiento debe tener 4 dígitos"
    },
    "releaseCatalog": {
        "required": "Se requiere lanzamientos en el catálogo",
        "numeric": "El valor no es un número"
    },
    "logo": {
        "required": "El logo es obligatorio",
        "dimensions": "El tamaño del logo del sello debe ser 1000 x 1000 px, JPG/JPEG/PNG.",
        "choose": "Por favor, elige una imagen",
        "file": "Por favor, sube formatos JPG o PNG, resolución mínima 1000x1000px. Tamaño máximo 2MB"
    },
    "promo_graphic": {
        "dimensions": "El tamaño del gráfico promocional del sello debe ser 960 x 150 px, JPG/JPEG/PNG.",
        "choose": "Por favor, elige una imagen",
        "file": "Sube formatos JPG o PNG, resolución mínima 960x150px"
    }
};

export default labelsValidationES;